import React, {
    useState,
} from "react";

import {
    FaEye,
    FaEyeSlash,
    FaLock,
    FaShieldAlt,
} from "react-icons/fa";

import {
    useDispatch,
    useSelector,
} from "react-redux";

import {
    changeTenantPassword,

    selectTenantPasswordUpdating,

    selectTenantPasswordUpdateError,

    selectTenantPasswordUpdateSuccess,
} from "../../../../../store/tenantProfile/tenantProfileSlice";


const ChangePasswordSettings =
    () => {

        const dispatch =
            useDispatch();


        /*
        |--------------------------------------------------------------------------
        | REDUX
        |--------------------------------------------------------------------------
        */

        const updating =
            useSelector(
                selectTenantPasswordUpdating
            );


        const updateError =
            useSelector(
                selectTenantPasswordUpdateError
            );


        const updateSuccess =
            useSelector(
                selectTenantPasswordUpdateSuccess
            );


        /*
        |--------------------------------------------------------------------------
        | FORM
        |--------------------------------------------------------------------------
        */

        const [
            form,
            setForm,
        ] =
            useState({

                currentPassword:
                    "",

                newPassword:
                    "",

                confirmPassword:
                    "",

            });


        /*
        |--------------------------------------------------------------------------
        | PASSWORD VISIBILITY
        |--------------------------------------------------------------------------
        */

        const [
            visibility,
            setVisibility,
        ] =
            useState({

                current:
                    false,

                new:
                    false,

                confirm:
                    false,

            });


        /*
        |--------------------------------------------------------------------------
        | LOCAL ERROR
        |--------------------------------------------------------------------------
        */

        const [
            localError,
            setLocalError,
        ] =
            useState(
                ""
            );


        /*
        |--------------------------------------------------------------------------
        | CHANGE
        |--------------------------------------------------------------------------
        */

        const handleChange =
            (
                event
            ) => {

                const {
                    name,
                    value,
                } =
                    event.target;


                setLocalError(
                    ""
                );


                setForm(
                    (
                        previous
                    ) => ({

                        ...previous,

                        [name]:
                            value,

                    })
                );

            };


        /*
        |--------------------------------------------------------------------------
        | TOGGLE VISIBILITY
        |--------------------------------------------------------------------------
        */

        const toggleVisibility =
            (
                field
            ) => {

                setVisibility(
                    (
                        previous
                    ) => ({

                        ...previous,

                        [field]:
                            !previous[
                                field
                            ],

                    })
                );

            };


        /*
        |--------------------------------------------------------------------------
        | SUBMIT
        |--------------------------------------------------------------------------
        */

        const handleSubmit =
            async (
                event
            ) => {

                event.preventDefault();


                setLocalError(
                    ""
                );


                /*
                |--------------------------------------------------------------------------
                | REQUIRED
                |--------------------------------------------------------------------------
                */

                if (
                    !form.currentPassword ||
                    !form.newPassword ||
                    !form.confirmPassword
                ) {

                    setLocalError(
                        "Please complete all password fields."
                    );

                    return;

                }


                /*
                |--------------------------------------------------------------------------
                | LENGTH
                |--------------------------------------------------------------------------
                */

                if (
                    form.newPassword.length <
                    8
                ) {

                    setLocalError(
                        "New password must contain at least 8 characters."
                    );

                    return;

                }


                /*
                |--------------------------------------------------------------------------
                | MATCH
                |--------------------------------------------------------------------------
                */

                if (
                    form.newPassword !==
                    form.confirmPassword
                ) {

                    setLocalError(
                        "New password and confirm password do not match."
                    );

                    return;

                }


                /*
                |--------------------------------------------------------------------------
                | SUBMIT
                |--------------------------------------------------------------------------
                */

                const result =
                    await dispatch(
                        changeTenantPassword({

                            currentPassword:
                                form.currentPassword,

                            newPassword:
                                form.newPassword,

                            confirmPassword:
                                form.confirmPassword,

                        })
                    );


                /*
                |--------------------------------------------------------------------------
                | SUCCESS
                |--------------------------------------------------------------------------
                */

                if (
                    changeTenantPassword
                        .fulfilled
                        .match(
                            result
                        )
                ) {

                    setForm({

                        currentPassword:
                            "",

                        newPassword:
                            "",

                        confirmPassword:
                            "",

                    });

                }

            };


        return (

            <div className="settings-password-page">

                {/* ============================================================
                    HEADER
                ============================================================ */}

                <div className="settings-section-header">

                    <div>

                        <h2>
                            Change Password
                        </h2>

                        <p>
                            Update your account password and keep your account secure.
                        </p>

                    </div>

                </div>


                {/* ============================================================
                    SECURITY INFO
                ============================================================ */}

                <div className="settings-security-card">

                    <div className="settings-security-card__icon">

                        <FaShieldAlt />

                    </div>


                    <div>

                        <strong>
                            Protect your account
                        </strong>

                        <p>
                            Use at least 8 characters and avoid reusing your current password.
                        </p>

                    </div>

                </div>


                {/* ============================================================
                    SUCCESS
                ============================================================ */}

                {
                    updateSuccess &&
                    (
                        <div className="settings-success">

                            Password changed successfully.

                        </div>
                    )
                }


                {/* ============================================================
                    LOCAL ERROR
                ============================================================ */}

                {
                    localError &&
                    (
                        <div className="settings-error">

                            {localError}

                        </div>
                    )
                }


                {/* ============================================================
                    API ERROR
                ============================================================ */}

                {
                    updateError &&
                    (
                        <div className="settings-error">

                            {
                                updateError
                                    ?.message ||
                                "Unable to change password."
                            }

                        </div>
                    )
                }


                {/* ============================================================
                    FORM
                ============================================================ */}

                <form
                    onSubmit={
                        handleSubmit
                    }

                    className="settings-password-form"
                >

                    {/* CURRENT PASSWORD */}

                    <div className="settings-field">

                        <label>
                            Current Password
                        </label>


                        <div className="settings-password-input">

                            <FaLock
                                className="settings-password-input__lock"
                            />


                            <input
                                type={
                                    visibility.current
                                        ? "text"
                                        : "password"
                                }

                                name="currentPassword"

                                value={
                                    form.currentPassword
                                }

                                onChange={
                                    handleChange
                                }

                                placeholder="Enter current password"

                                autoComplete="current-password"
                            />


                            <button
                                type="button"

                                onClick={
                                    () =>
                                        toggleVisibility(
                                            "current"
                                        )
                                }
                            >

                                {
                                    visibility.current
                                        ?
                                        <FaEyeSlash />
                                        :
                                        <FaEye />
                                }

                            </button>

                        </div>

                    </div>


                    {/* NEW PASSWORD */}

                    <div className="settings-field">

                        <label>
                            New Password
                        </label>


                        <div className="settings-password-input">

                            <FaLock
                                className="settings-password-input__lock"
                            />


                            <input
                                type={
                                    visibility.new
                                        ? "text"
                                        : "password"
                                }

                                name="newPassword"

                                value={
                                    form.newPassword
                                }

                                onChange={
                                    handleChange
                                }

                                placeholder="Enter new password"

                                autoComplete="new-password"
                            />


                            <button
                                type="button"

                                onClick={
                                    () =>
                                        toggleVisibility(
                                            "new"
                                        )
                                }
                            >

                                {
                                    visibility.new
                                        ?
                                        <FaEyeSlash />
                                        :
                                        <FaEye />
                                }

                            </button>

                        </div>


                        <small className="settings-field-help">

                            Minimum 8 characters.

                        </small>

                    </div>


                    {/* CONFIRM */}

                    <div className="settings-field">

                        <label>
                            Confirm New Password
                        </label>


                        <div className="settings-password-input">

                            <FaLock
                                className="settings-password-input__lock"
                            />


                            <input
                                type={
                                    visibility.confirm
                                        ? "text"
                                        : "password"
                                }

                                name="confirmPassword"

                                value={
                                    form.confirmPassword
                                }

                                onChange={
                                    handleChange
                                }

                                placeholder="Confirm new password"

                                autoComplete="new-password"
                            />


                            <button
                                type="button"

                                onClick={
                                    () =>
                                        toggleVisibility(
                                            "confirm"
                                        )
                                }
                            >

                                {
                                    visibility.confirm
                                        ?
                                        <FaEyeSlash />
                                        :
                                        <FaEye />
                                }

                            </button>

                        </div>

                    </div>


                    {/* ACTION */}

                    <div className="settings-actions">

                        <button
                            type="submit"

                            className="settings-save-button"

                            disabled={
                                updating
                            }
                        >

                            {
                                updating
                                    ?
                                    "Changing Password..."
                                    :
                                    "Change Password"
                            }

                        </button>

                    </div>

                </form>

            </div>

        );

    };


export default ChangePasswordSettings;